@if ((isCreationProcess$ | async) === false) {
  <div>
    <h1 class="text-2xl font-bold">
      {{ 'monetization.title' | translate }}
    </h1>
    <div class="w-full flex relative">
      <rk-admob class="w-full"></rk-admob>
    </div>
  </div>
}
